/* eslint-disable no-mixed-operators, no-bitwise */

/**
 * @name        Guid Utility
 * @file        guid-utility.js
 * @description Generates a RFC4122 v4 compliant GUID
 * @author      Jeremy Cox
 * @copyright   © 2017 Bank of America Corporation. All rights reserved.
 */

const guid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};

export { guid as default };
